import { render, staticRenderFns } from "./SMSCampaignEditRoute.vue?vue&type=template&id=1bedde58&scoped=true&"
import script from "./SMSCampaignEditRoute.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignEditRoute.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignEditRoute.vue?vue&type=style&index=0&id=1bedde58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bedde58",
  null
  
)

export default component.exports